// 公共数据映射
import {mapGetters} from 'vuex';
export default {
    computed:{
        ...mapGetters('dictionary',['getCarrierServiceList','getNextOrgList', 'getCarrierServiceAllList']),
        //组织
        getOrgOpt(){
            return this.getNextOrgList;
            // return this.getOrgList.map(function(item){
            //     return {
            //         label:item.name,
            //         value:item.id,
            //     }
            // })
        },
        //承运商服务
        getCarrierServiceOpt(){
            return this.getCarrierServiceAllList;
            // return this.getCarrierServiceList.map(function(item){
            //     return {
            //         label:`${item.carrierServiceCode}(${item.carrierServiceName})`,
            //         value:item.id,
            //         attach:{...item}
            //     }
            // })
        },
        //规则标识
        getRulelabelOpt(){
            return [{
                label:this.$t('fbb.carrier.mixin_length', { defaultValue: '长度' }),
                value:"LENGTH"
            },{
                label:this.$t('fbb.carrier.mixin_volume', { defaultValue: '体积重' }),
                value:"VOLUME_WEIGHT"
            },{
                label:this.$t('global.common.weight', { defaultValue: '重量' }),
                value:"WEIGHT"
            }]
        },
        //规则匹配类型
        getRuleTypeOpt(){
            return [{
                label:this.$t('fbb.carrier.mixin_formula', { defaultValue: '公式' }),
                value:"FORMULA"
            },{
                label:this.$t('fbb.carrier.mixin_maxmin', { defaultValue: '最大值/最小值' }),
                value:"MAXMIN_VALUE"
            }]
        },
        getRuleGroupOpt(){
            const arr=[];
            for (let index = 1; index < 11; index++) {
                arr.push({
                    label: this.$t('fbb.carrier.extra_group', { defaultValue: '分组' })+index,
                    value: index
                })
            }
            return arr
        },
        getLogList() {
			return [
				{
					title: this.$t('global.common.operator', { defaultValue: '操作人' }),
					key: "opUserName"
				},
				{
					title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
					key: "opAction"
				},
				{
					title: this.$t('fbb.basicdata.carrier_change_field', { defaultValue: '更改字段' }),
					key: "changeField"
				},
				{
					title: this.$t('fbb.basicdata.carrier_change_before', { defaultValue: '更改前值' }),
					key: "beforeChange"
				},
				{
					title: this.$t('fbb.basicdata.carrier_change_after', { defaultValue: '更改后值' }),
					key: "afterChange"
				},
				{
					title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
					key: "opAt"
				}
			];
		},

    }
}
